
import React from 'react';
import { FaEnvelope, FaHandshake, FaChevronDown } from 'react-icons/fa';

function Contact() {
  return (
    <section id="contact" style={{
      background: 'transparent',
      borderRadius: '16px',
      position: 'relative',
      border: '1px solid rgba(148, 163, 184, 0.24)'
    }}>
      <h2 style={{ 
        marginBottom: '20px',
        animation: 'slideInUp 0.6s ease-out',
        margin: '0 auto',
        maxWidth: '800px',
        textAlign: 'center',
      }}>
        Get in Touch
      </h2>
      
      <p style={{
        fontSize: '1.1rem',
        color: 'var(--text-secondary)',
        maxWidth: '700px',
        margin: '0 auto 60px',
        lineHeight: '1.6'
      }}>
        Ready to transform your healthcare operations with AI? Let's discuss how 
        our solutions can address your specific challenges and goals.
      </p>
      
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
        gap: '50px',
        alignItems: 'start'
      }}>
        {/* Contact Form */}
        <div className="glass-card" style={{ 
          padding: '40px',
          animation: 'slideInLeft 0.8s ease-out 0.2s both'
        }}>
          <h3 style={{
            fontSize: '1.3rem',
            fontWeight: '600',
            color: '#2d3748',
            marginBottom: '30px',
            textAlign: 'left'
          }}>
            Contact Our Team
          </h3>
          
          <form 
            action="https://formspree.io/f/xblkoqzb" 
            method="POST" 
            style={{ textAlign: 'left' }}
            onSubmit={(e) => {
              // Optionally show a message or disable button on submit
              // e.target.submit(); // default behavior
            }}
          >
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#4a5568',
                fontWeight: '500',
                fontSize: '0.9rem'
              }}>
                Name *
              </label>
              <input 
                type="text" 
                name="name"
                placeholder="Dr. Jane Smith" 
                required 
                style={{ marginBottom: '0' }}
              />
            </div>
            
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#4a5568',
                fontWeight: '500',
                fontSize: '0.9rem'
              }}>
                Organization/Company *
              </label>
              <input 
                type="text" 
                name="organization"
                placeholder="Healthcare System / Hospital / Clinic" 
                required 
                style={{ marginBottom: '0' }}
              />
            </div>
            
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#4a5568',
                fontWeight: '500',
                fontSize: '0.9rem'
              }}>
                Email *
              </label>
              <input 
                type="email" 
                name="email"
                placeholder="contact@healthcare.com" 
                required 
                style={{ marginBottom: '0' }}
              />
            </div>
            
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#4a5568',
                fontWeight: '500',
                fontSize: '0.9rem'
              }}>
                Area of Interest
              </label>
              <div style={{
                position: 'relative',
                width: '100%'
              }}>
                <select name="interest" style={{
                  padding: '16px 20px',
                  width: '100%',
                  border: '1px solid rgba(148, 163, 184, 0.35)',
                  borderRadius: '12px',
                  fontSize: '1rem',
                  background: 'rgba(15, 23, 42, 0.7)',
                  appearance: 'none',
                  WebkitAppearance: 'none',
                  MozAppearance: 'none',
                  outline: 'none',
                  cursor: 'pointer',
                  color: '#e2e8f0',
                  fontWeight: 500,
                  transition: 'all 0.3s ease',
                  boxShadow: '0 2px 8px rgba(2,6,23,0.25)'
                }}>
                  <option value="">Select your interest</option>
                  <option>Multimodal Data Capture</option>
                  <option>Narrow AI Feature Extraction</option>
                  <option>Long-term Health Evaluation</option>
                  <option>AI Agent Intelligence</option>
                  <option>Partnership Opportunities</option>
                  <option>Other</option>
                </select>
                <FaChevronDown style={{
                  position: 'absolute',
                  right: '18px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  pointerEvents: 'none',
                  color: '#718096',
                  fontSize: '1.1rem'
                }} />
              </div>
            </div>
            
            <div style={{ marginBottom: '30px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#4a5568',
                fontWeight: '500',
                fontSize: '0.9rem'
              }}>
                Message / Requirements
              </label>
              <textarea 
                name="message"
                placeholder="Tell us about your healthcare challenges, current systems, and how we might help improve your operations..." 
                rows="5"
                style={{ 
                  marginBottom: '0',
                  resize: 'vertical',
                  minHeight: '120px'
                }}
              ></textarea>
            </div>
            
            <button type="submit" style={{
              width: '100%'
            }}>
              Send Inquiry
            </button>
            <p style={{ fontSize: '0.9rem', color: '#718096', marginTop: '18px' }}>
              We use Formspree to securely deliver your inquiry to our team. Your information is never shared.
            </p>
          </form>
        </div>
        
        {/* Contact Information */}
        <div style={{
          animation: 'slideInRight 0.8s ease-out 0.4s both'
        }}>
          <div className="glass-card" style={{ 
            padding: '40px',
            textAlign: 'left',
            marginBottom: '30px'
          }}>
            <h3 style={{
              fontSize: '1.3rem',
              fontWeight: '600',
              color: '#2d3748',
              marginBottom: '25px'
            }}>
              Contact Information
            </h3>
            
            <div style={{ marginBottom: '25px' }}>
              <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '15px',
                marginBottom: '15px'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  background: '#2d3748',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '18px',
                  flexShrink: 0
                }}>
                  <FaEnvelope color="#fff" />
                </div>
                <div>
                  <p style={{ 
                    fontWeight: '600', 
                    color: '#2d3748',
                    margin: '0 0 5px 0',
                    fontSize: '0.95rem'
                  }}>
                    Business Inquiries
                  </p>
                  <p style={{ 
                    color: '#4a5568',
                    margin: 0,
                    fontSize: '0.9rem'
                  }}>
                    dabra@dabra.tech
                  </p>
                </div>
              </div>
            </div>
            
            <div style={{ marginBottom: '25px' }}>
              <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '15px',
                marginBottom: '15px'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  background: '#2d3748',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '18px',
                  flexShrink: 0
                }}>
                  <FaHandshake color="#fff" />
                </div>
                <div>
                  <p style={{ 
                    fontWeight: '600', 
                    color: '#2d3748',
                    margin: '0 0 5px 0',
                    fontSize: '0.95rem'
                  }}>
                    Sales & Partnerships
                  </p>
                  <p style={{ 
                    color: '#4a5568',
                    margin: 0,
                    fontSize: '0.9rem'
                  }}>
                    +420 606 208 251
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Research info */}
          <div className="glass-card" style={{ 
            padding: '30px',
            textAlign: 'left',
            background: 'rgba(15, 23, 42, 0.72)',
            border: '1px solid rgba(148, 163, 184, 0.28)'
          }}>
            <h4 style={{
              fontSize: '1.1rem',
              fontWeight: '600',
              color: 'var(--text-primary)',
              marginBottom: '15px'
            }}>
              Partnership Opportunities
            </h4>
            <ul style={{
              fontSize: '0.95rem',
              color: 'var(--text-secondary)',
              lineHeight: '1.7',
              margin: '0 0 0 18px',
              padding: 0
            }}>
              <li style={{ marginBottom: '8px' }}>Healthcare system integration</li>
              <li style={{ marginBottom: '8px' }}>Clinical workflow optimization</li>
              <li style={{ marginBottom: '8px' }}>Custom AI solution development</li>
              <li>Technology licensing</li>
            </ul>
            
            <div style={{
              marginTop: '20px',
              padding: '15px',
              background: 'rgba(6, 182, 212, 0.08)',
              borderRadius: '8px',
              border: '1px solid rgba(6, 182, 212, 0.24)'
            }}>
              <p style={{
                fontSize: '0.85rem',
                color: '#718096',
                margin: 0,
                fontStyle: 'italic'
              }}>
                We typically respond to business inquiries within 1-2 business days
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
